<template>
  <span>
    <template v-if="!isHideBtn">
      <span v-if="isText"
        class="btn-text"
        @click="openExportModal()">
        {{ btnText }}
      </span>

      <a-button v-else
        type="primary"
        :disabled="disabled"
        @click="openExportModal()">
        <span>{{ btnText }}</span>
      </a-button>
    </template>
    <template v-if="exportModalVisible">
      <ExportModal v-model:visible="exportModalVisible"
        :queryParams="queryParams"
        :type="params?.().asyncTaskType"
        :showMarkedStatus="showMarkedStatus"
        :title="modalTitle"
        @cancel="cancelClicked"
        @confirm="confirmClicked" />
    </template>
  </span>
</template>

<script lang="ts" setup name="CustomExport">
import { computed, ref } from 'vue';
import { message } from "ant-design-vue";
import { ExportParams, QueryParams } from './src/config';
import ExportModal from './src/components/exportModal.vue';
import { commonExportEnum } from '/@/enums/commonExportEnmu';
import { createAsyncMessage } from '/@/utils/htmlMessage';
import { commonExportFetch } from './src/api';

const props = withDefaults(defineProps<{
  isHideBtn?: boolean,
  btnText?: string,
  modalTitle?: string,
  isSupportExportAll?: boolean,
  maxCount?: number,
  params?: () => ExportParams,
  exportType?: string, // 部分导出exportType与请求的type不一致
  isText?: boolean,
  totalCount?: number, // 外部表格是否有数据
  queryParams?: () => QueryParams,
  isCommonExport?: boolean, // 是否是通用导出，通用导出会有一些特殊处理
  asyncTaskType?: string, // 导出需要的任务类型， 默认与params中的asyncTaskType一致，特殊情况可以单独传值
  showMarkedStatus?: boolean, // 是否显示标注状态
  omitMarkedStatus?: boolean, // 是否从导出请求中移除标注状态
}>(), {
  isHideBtn: false,
  btnText: '导出',
  modalTitle: '导出',
  isSupportExportAll: true,
  maxCount: commonExportEnum.MAX_COUNT,
  exportType: '',
  isText: false,
  isCommonExport: true,
  asyncTaskType: '',
  showMarkedStatus: false,
  omitMarkedStatus: false,
})

const emit = defineEmits(['exportDone', 'cancel']);

const disabled = computed(() => {
  // 当没有选中项：
  // 1、且不支持全部导出
  // 2、支持全部导出但是外部表格没有数据
  return !props.params()?.ids?.length && (!props.isSupportExportAll || (props.isSupportExportAll && !props.totalCount));
})
const exportModalVisible = ref(false);
const openExportModal = (single = false) => {
  if (props.maxCount && props.params()?.ids?.length > props.maxCount) {
    message.warning("数据量太大,建议分批导出数据哦");
    return;
  }

  exportModalVisible.value = true;
}

const cancelClicked = () => {
  emit('cancel')
};

let isSubmitting = false;
const confirmClicked = async ({selected, ...fileConfig}) => {
  if (props.showMarkedStatus && fileConfig?.approveStatusList?.length == 0) {
    message.warning("请选择标注状态");
    return;
  }
  if (props.omitMarkedStatus) {
    delete fileConfig.approveStatusList;
  }
  if (isSubmitting) return;
  isSubmitting = true;
  const resultSelected = selected.map(item => {
    if (item.sysExportNodeColumnList?.length) {
      const newChildren = item.sysExportNodeColumnList.map(childItem => ({
        id: childItem.id,
        nodeCode: childItem.nodeCode,
        nodeName: childItem.nodeName,
      }))

      return {
        id: item.id,
        nodeCode: item.nodeCode,
        nodeName: item.nodeName,
        sysExportNodeColumnList: newChildren,
      }
    }
  }).filter(item => item)

  const propParams = props.params()

  let params = {
    ...propParams,
    exportConfig: JSON.stringify(resultSelected),
    ...fileConfig,
  }
  
  if(props.isCommonExport) {
    params.commonExportType = props.exportType || propParams.asyncTaskType
    params.asyncTaskType = commonExportEnum.COMMON_EXPORT
  }
  // 部分导出需要单独传任务类型，特殊情况可以单独传值，默认与params中的asyncTaskType一致
  if(!!props.asyncTaskType) {
    params.asyncTaskType = props.asyncTaskType
  }

  try {
    await commonExportFetch(params)
    createAsyncMessage('export')
    emit('exportDone')
    exportModalVisible.value = false;
  } catch (error) {}

  isSubmitting = false;
}

defineExpose({
  openExportModal
});

</script>

<style lang="less" scoped>
.btn-text {
  display: inline-block;
}
</style>
